import React from "react";
import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Button } from "./ui/button";
import ExclusiveBadge from "./ExclusiveBadge";
import Header from "./Header";

const NotFound: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex h-screen w-full flex-col items-center justify-center gap-10 px-4 text-center">
      <Header className="fixed top-0 right-0 left-0 z-50" />
      <div className="flex max-w-sm flex-col items-center justify-center gap-2">
        <ExclusiveBadge className="mb-4 size-20 text-neutral-50" />
        <h1 className="text-2xl font-bold">{t("notfound_title")}</h1>
        <p className="text-muted-foreground text-md text-balance">
          {t("notfound_message")}
        </p>
      </div>
      <div className="flex w-full flex-col gap-2 md:flex-row md:justify-center">
        <Button className="w-full md:w-auto" asChild>
          <Link to="/">{t("notfound_home_button")}</Link>
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
